import { render } from "./TopLogos.vue?vue&type=template&id=5ecd1292"
import script from "./TopLogos.vue?vue&type=script&lang=js"
export * from "./TopLogos.vue?vue&type=script&lang=js"

import "./TopLogos.vue?vue&type=style&index=0&id=5ecd1292&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__